// /changelog: the public changelog (W4-5; OD-P16), inside the site frame
// (routes/_site.tsx). The loader starts the fetch without waiting for it, so
// the page's code and its data download together and a hover on a
// Changelog link warms both.
import { createFileRoute } from '@tanstack/react-router';
import { publicChangelogQuery } from '@/features/site/changelog/publicChangelog';
import { SiteChangelogPage } from '@/features/site/changelog/SiteChangelogPage';

export const Route = createFileRoute('/_site/changelog')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(publicChangelogQuery);
  },
  component: SiteChangelogPage,
});
